import React, { createContext, useState } from "react";

import "./Businesses.css";
import indu1 from "../../images/Businesses/Indu1.png";
import indu2 from "../../images/Businesses/Indu2.png";
import indu3 from "../../images/Businesses/Indu3.png";
import indu4 from "../../images/Businesses/Indu4.png";

const data = [
    {
      id: 1,
      industry: 'Водное хозяйство',
      caption: `ЖКХ и водное хозяйство являются основными потребителями насосного оборудования,
                связанного с водоснабжением и водоотведением. ДКМ Системы производят
                специализированное и общепромышленное насосное оборудование для подачи,
                транспортировки и отвода воды.
                Компания специализируется на разработке и производстве насосного и
                сопутствующего оборудования для систем горячего и холодного
                водоснабжения/теплоснабжения, водоотведения и водоочистки, в системах
                пожаротушения промышленных и гражданских объектов, для перекачивания
                технической воды на объектах теплоэнергетики, включая АЭС, а также для
                подачи пластовой жидкости на нефтяных месторождениях.
      `,
      image: indu1,
    },
    {
      id: 2,
      industry: 'Энергетический комплекс',
      caption: `Одними из ключевых элементов, входящими в технологическую схему процесса
      производства электроэнергии, являются насосы. Данный тип оборудования используется
      в работе теплообменной системы станции, парогенераторов, турбин, котельной и так далее.
      Основная задача насосов заключается в перемещении по трубопроводам станции различных
      жидкостей и газообразных сред. ДКМ Системы производят широкую линейку основных и
      вспомогательных насосов для предприятий электроэнергетики.
      В соответствии с требованиями заказчиков НИОКР нашей компании занимается разработкой
      и внедрением надежных и экономичных систем перекачки, отвечающих требованиям непрерывно
      растущей промышленной энергетики.
      `,
      image: indu2,
    },
    {
      id: 3,
      industry: 'Нефтегазовая промышленность',
      caption: `Нефтяная промышленность является основным сектором экономики Российской Федерации.
      Ежедневно миллионы тонн нефти добываются с помощью специального оборудования - нефтяных насосов.
      Насосы нефтегазовой отрасли предназначены для перекачки и транспортировки нефти и нефтепродуктов,
      к которым относятся мазут, углеводороды, бензин, керосин и другие жидкости.
      Насосы должны обеспечить безопасность и эффективность процесса перекачивания нефтепродуктов,
      это самое распространенное оборудование для данной отрасли.
      Продукты, услуги и решения компании ООО «ДКМ Системы» используются во многих технологических
      процессах на всех этапах добычи, транспорта и переработки углеводородов, однако область применения
      насосного оборудования очень широка, она не ограничивается только предприятиями по нефтедобыче.
      `,
      image: indu3,
    },
    {
      id: 4,
      industry: 'Химическая промышленность',
      caption: `Химическое производство требует перекачки разных веществ – чистых и с примесями, вязких
      и жидких, нейтральных и едких, агрессивных. Поэтому промышленные насосы для этой отрасли должны быть
      устойчивыми к разным средам, выполненными из подходящих материалов и обладать соответствующими
      конструкционными особенностями.
      Насосы, поставляемые компанией, широко используются для перекачки водных растворов;
      вредных, горючих, легковоспламеняющихся и взрывоопасных жидкостей; различных реагентов;
      полимеров, каучука и других химически активных жидкостей; масел, красок, косметических жидкостей
      и кремов, моющих средств.
      `,
      image: indu4,
    },
]

function Businesses() {
  const [clicked, setClicked] = useState(1);

  const handleClick = (e) => {
    setClicked(parseInt(e.target.value));
  };

  return (
    <div className="businesses">
      <div className="grid-cont">
        <div className="grid-item1">
          <div className="businesses__menu">
            <div className="business__areas">
              ОТРАСЛИ
            </div>
            <div className="business__projects">
              Реализованные проекты
            </div>
            <div className="business__menu-buttons">
              {data?.map((entry, index) => (
                <button
                  className="business__menu-button"
                  value={+entry.id}
                    style={entry.id === clicked ?
                      {textDecoration: 'underline 2px', textUnderlineOffset: '5px', color: 'white'}
                      : {}
                    }
                    onClick={handleClick}
                >
                  {entry.industry}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="grid-item2">
          <div className="business__caption">
              <div className="industry__header">
                {data[clicked-1]?.industry}
              </div>
              <div className="industry__text">
                {data[clicked-1]?.caption}
              </div>
            </div>
        </div>
        <div className="grid-item3">
          <img src={data[clicked-1].image} align="center"/>
        </div>
      </div>
    </div>
  );
}

export default Businesses;
